import Udesk from 'Udesk';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import { getInspectionDataPointNotesList } from 'src/api/inspectionDataPointNotes/list';
import { InspectionDataPointNoteFoundResponse } from 'src/api/types';

interface UseAnnotationProps {
    inspectionId?: number;
    isAppeal?: boolean;
    sdkOptions?: any;
}

export const useAnnotation = (props: UseAnnotationProps) => {
    const { inspectionId, isAppeal, sdkOptions } = props;

    const [data, setData] = useState<InspectionDataPointNoteFoundResponse[]>();

    const { loading, refresh } = useRequest(
        isAppeal
            ? () =>
                  Udesk.business.sdkAjax.get(
                      `/open_api_v1/inspection/note/${inspectionId}`,
                      sdkOptions,
                      {
                          props,
                      }
                  )
            : () => getInspectionDataPointNotesList({ params: { inspectionId: inspectionId! } }),
        {
            ready: !!inspectionId,
            refreshDeps: [inspectionId],
            onSuccess: (res) => {
                setData((res as any).data);
            },
        }
    );

    return {
        loading,
        refresh,
        data,
    };
};
